import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
const { WizSpin, WizCard, WizForm, WizRow, WizCol, WizButton } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool

const findParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/integrationCounseling/manager/antecedentIntervention/evaluation/examine') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('generalManagerEvaluationExamine', record)
        } else {
            record = Session.get('generalManagerEvaluationExamine') || {}
        }
    }
    if (history.location && history.location.pathname === '/integrationCounseling/manager/antecedentIntervention/stationmasterEvaluation/examine') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('stationmasterEvaluationExamine', record)
        } else {
            record = Session.get('stationmasterEvaluationExamine') || {}
        }
    }
    return record
}

class SalesOpeningExamine extends WizContainer {

    componentName = 'SalesOpeningExamine'

    constructor(props) {
        super(props)
        let record = findParamRecord(props.history)
        this.state = {
            record
        }
    }

    _componentDidMount() {
        this._detail()
    }

    _detail = () => {
        const { processContentId } = this.state.record
        this.doAction({
            path: 'counselingProcess/managerEvaluationDetail',
            payload: {
                key: 'managerEvaluationDetail@' + processContentId,
                apiParams: {
                    tutorContentId: processContentId
                }
            }
        })
    }

    _onSub = () => {
        const { processContentId } = this.state.record
        this.refs.form.validateFields((err, values) => {
            if (!err) {
                let { fullName, evaluationTime, evaluationState } = values
                let params = {
                    fullName,
                    evaluationTime: evaluationTime.format('YYYY-MM-DD 00:00:00'),
                    evaluationState,
                    tutorContentId: processContentId
                }
                this.doAction({
                    path: 'counselingProcess/managerEvaluationSave',
                    payload: {
                        key: 'managerEvaluationSave@' + processContentId,
                        apiParams: params
                    }
                })
            }
        })
    }

    propsAndStateOnChange = {
        save: this._saveOnChange.bind(this)
    }

    _saveOnChange(nextProps, nextState) {
        if (nextProps.save.code === 1) {
            wizNotice.success('操作成功')
            this.jumpPage('goBack')
        } else {
            wizNotice.error(nextProps.save.msg)
        }
    }

    _renderFooter = () => {
        return (
            <WizRow className='form-btns row-item'>
                <WizCol span={24}>
                    <WizButton type='primary' onClick={() => this._onSub()}>{'确认'}</WizButton>
                </WizCol>
            </WizRow>
        )
    }

    render() {
        let { detail, counselingProcessLoading } = this.props
        const { moduleType } = this.state.record
        let columns = [{
            title: '姓名',
            name: 'fullName',
            dataIndex: 'fullName',
            formItem: {
                style: { maxWidth: 800 },
                maxLength: 20,
                rules: [{ required: true, message: '请输入姓名' }]
            }
        }, {
            title: '测评日期',
            name: 'evaluationTime',
            dataIndex: 'evaluationTime',
            formItem: {
                type: 'date',
                style: { maxWidth: 800 },
                rules: [{ required: true, message: '请选择测评日期' }]
            },
        }, {
            title: '测评结果',
            name: 'evaluationState',
            dataIndex: 'evaluationState',
            dict: [
                { code: 1, codeName: '合格' },
                { code: 2, codeName: '不合格' },
                { code: 0, codeName: '未参加' }
            ],
            formItem: {
                type: 'select',
                style: { maxWidth: 800 },
                rules: [{ required: true, message: '请选择测评结果' }]
            }
        }]
        let formProps = {
            ref: 'form',
            columns,
            record: detail.data,
            preview: null,
            footer: this._renderFooter(),
            formItemLayout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 17 }
            },
            style: { maxWidth: '100%', width: '100%' }
        }
        return (
            <WizSpin spinning={counselingProcessLoading} >
                <WizCard title={`${moduleType === 0 ? '总经理' : '站长'}测评情况评审`}>
                    <WizForm {...formProps} />
                </WizCard>
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { counselingProcess } = state
    const { processContentId } = findParamRecord(ownProps.history)
    const detail = modelUtils.getModelEntity(counselingProcess, 'managerEvaluationDetail@' + processContentId)
    const save = modelUtils.getModelEntity(counselingProcess, 'managerEvaluationSave@' + processContentId)
    const loading = modelUtils.getLoadingState(state, 'counselingProcess')
    return {
        detail,
        save,
        ...loading
    }
}

export default connect(mapStateToProps)(SalesOpeningExamine)


